module.exports = __webpack_public_path__ + "static/media/avatar-4.3e16a355.jpg";